export default __webpack_public_path__ + "static/media/spa-banner-04.c5692bdf.jpg";